export default __webpack_public_path__ + "98a6f6688aa0d5a7c1c369e56242ea18.png";